import { Component } from '@angular/core';
import { BaseBPWizardFormComponent, PROFILE_ATTRIBUTES_FORM } from '../base-bp-wizard-form.component';
import { FormlyInputType, GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { StateService, TransitionService } from '@uirouter/angular';
import { BPWizardService } from '../bp-wizard.service';
import { BPProfilesService } from '../../bp-profiles.service';
import { BPProfilesDataService } from '../../bp-profiles-data.service';
import { GaValidateService } from '../../../../shared/formly/ga-validate.service';
import { TextComponent } from '../../../../shared/text/text.component';
import { IProfileAttributeValue } from '../../profile-attributes/bp-profiles-attributes.service';
import { util } from '../../../../shared/util';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { BPProfilesTCDataService } from '../../advanced/tc/bp-profiles-tc-data.service';

@Component({
  selector: 'bp-wizard-company-margin',
  template: `
    <h2 [class.step-complete]="stepComplete"><text key="HEADING"></text></h2>
    <formly [form]="form" [model]="model" [fields]="fields"></formly>
  `
})
export class BPWizardCompanyMarginComponent extends BaseBPWizardFormComponent {

  constructor(
    private authService:AuthService,
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    transitionService:TransitionService,
    bpWizardService:BPWizardService,
    bpProfilesService:BPProfilesService,
    bpProfilesDataService:BPProfilesDataService,
    validateService:GaValidateService,
    stateService:StateService,
    bpProfilesTCDataService:BPProfilesTCDataService
  ) {
    super(transitionService, bpWizardService, bpProfilesService, bpProfilesDataService, validateService, stateService, bpProfilesTCDataService);
    // marked as TC form
    this.formType = PROFILE_ATTRIBUTES_FORM;
  }

  protected createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aCustom()
        .withoutWrapper()
        .withComponent(TextComponent)
        .withWrapperClass('col-sm-12 margin-bottom-md')
        .withExtraOptions({
          templateOptions: {
            inputs: {
              key: 'DEFAULTMARGIN'
            }
          }
        })
        .build(),
      this.formlyService.anInput('resellerFee')
        .withInputType(FormlyInputType.NUMBER)
        .withEditable('defaultMargin')
        .withLabelClass(this.labelClass)
        .withValueClass('col-sm-2')
        .withAddOn('%')
        .withFormat((tc:IProfileAttributeValue) => tc.realValue)
        .withHideExpression(() => !(util.isNullOrUndefinedOrEmpty(this.model.resellerFee) || this.authService.checkAcslUser()))
        .withExtraOptions({
          templateOptions: {
            min: 0,
            max: 30
          }
        })
        .build(),
      this.formlyService.aValue('resellerFee')
        .withEditable('defaultMargin')
        .withLabelClass(this.labelClass)
        .withValueClass('col-sm-2')
        .withFormat(this.formattingService.formatPct)
        .withHideExpression(() => util.isNullOrUndefinedOrEmpty(this.model.resellerFee) || this.authService.checkAcslUser())
        .build(),
      this.formlyService.aTextarea('resellerFeeComment', 'GA.GENERAL.COMMENTS')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withExtraOptions({
          expressionProperties: {
            'templateOptions.required': ():boolean => this.model?.resellerFee !== this.model?.defaultResellerFee
          }
        })
        .build()
    ];
  }
}